import { motion } from "framer-motion";
import { IMAGES } from "../data/content";

const GALLERY = {
  fr: {
    label: "Les studios",
    title: "Onze studios, tous singuliers",
    intro:
      "Du studio Superior au Premium et Deluxe : papiers peints signés, kitchenette intégrée, terrasses et balcons privés. Chaque chambre a son caractère.",
    items: [
      { key: "studioGold", alt: "Studio Premium au papier peint chinoiserie doré, W16 Aparthotel" },
      { key: "studioBalcony", alt: "Studio Superior lumineux avec balcon, W16 Aparthotel" },
      { key: "studioRust", alt: "Détail tête de lit d'un studio Premium, W16 Aparthotel" },
      { key: "studioKitchen", alt: "Kitchenette et coin bureau d'un studio Superior, W16 Aparthotel" },
    ],
  },
  en: {
    label: "The studios",
    title: "Eleven studios, each one distinct",
    intro:
      "From Superior to Premium and Deluxe: signature wallpapers, built-in kitchenette, private terraces and balconies. Every room has its own character.",
    items: [
      { key: "studioGold", alt: "Premium studio with golden chinoiserie wallpaper, W16 Aparthotel" },
      { key: "studioBalcony", alt: "Bright Superior studio with balcony, W16 Aparthotel" },
      { key: "studioRust", alt: "Headboard detail in a Premium studio, W16 Aparthotel" },
      { key: "studioKitchen", alt: "Kitchenette and desk nook in a Superior studio, W16 Aparthotel" },
    ],
  },
};

const reveal = {
  hidden: { opacity: 0, y: 34 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.85, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] },
  }),
};

export const Gallery = ({ lang }) => {
  const g = GALLERY[lang];
  return (
    <section
      data-testid="gallery-section"
      className="mx-auto max-w-[1400px] px-6 md:px-10 py-20 md:py-28 border-t border-[#E6E3DC]"
    >
      <motion.div
        variants={reveal}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-80px" }}
        className="max-w-2xl"
      >
        <div className="flex items-center gap-4 mb-6">
          <span className="h-px w-10 bg-[#B0863A]" />
          <span className="overline text-[#7A8091]">{g.label}</span>
        </div>
        <h2 className="font-serif-display italic font-light text-[#171B26] text-4xl md:text-5xl leading-[1.05] tracking-tight">
          {g.title}
        </h2>
        <p className="mt-6 text-[#565C6B] text-base md:text-lg font-light leading-relaxed">
          {g.intro}
        </p>
      </motion.div>

      <div className="mt-10 md:mt-14 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
        {g.items.map((it, i) => (
          <motion.figure
            key={it.key}
            custom={i}
            variants={reveal}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-60px" }}
            data-testid={`gallery-item-${i}`}
            className="clip-frame group relative rounded-sm aspect-[4/5]"
          >
            <img
              src={IMAGES[it.key]}
              alt={it.alt}
              loading="lazy"
              className="img-zoom absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0E1420]/35 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          </motion.figure>
        ))}
      </div>
    </section>
  );
};
